<template>
    <psi-form-layout-section
        title="Change Password"
        icon="mdi-lock"
        btn-label="Change Password"
        btn-icon="mdi-lock-check"
        @section-save="savePassword"
    >
        <psi-form-section
            ref="update-password"
            :value="passwords"
            name="date-input-data"
            label=""
            :fields="fields"
            color="secondary"
            @update:password="updatePassword"
        ></psi-form-section>
        <v-alert
            type="error"
            border="top"
            icon="mdi-alert"
            prominent
            dismissible
            v-if="updateError"
        >
            {{ errorMessage }}
        </v-alert>
    </psi-form-layout-section>
</template>
<script>
export default {
    name: "update-passwords",
    components: {},
    props: {
        user: {
            type: Object,
            required: true,
        },
        updateError: {
            type: String,
            required: false,
            default: "",
        },
    },
    data() {
        return {
            errorMessage: "",
            passwords: {
                password_current: "",
                password: "",
                password_confirm: "",
            },
            fields: [
                {
                    type: "text",
                    name: "password_current",
                    key: "password_current",
                    format: "password",
                    label: "Current Password",
                    icon: this.$config("icons.password"),
                    required: true,
                },
                {
                    type: "text",
                    name: "password",
                    key: "password",
                    label: "New Password",
                    format: "password",
                    icon: this.$config("icons.password"),
                    required: true,
                },
                {
                    type: "text",
                    name: "password_confirm",
                    key: "password_confirm",
                    label: "Confirm Password",
                    format: "password",
                    icon: this.$config("icons.password"),
                    required: true,
                },
            ],
        };
    },
    watch: {
        updateError: {
            immediate: true,
            handler(error) {
                switch (error) {
                    case "password-confirm-failed": {
                        this.errorMessage =
                            "Current password doesn't match our records";
                    }
                }
            },
        },
    },

    methods: {
        updatePassword(value) {
            const index = this.fields.findIndex(
                (field) => field.name === "password_confirm"
            );
            let field = this.fields[index];
            field.rules = [(v) => v === value || "Passwords do not match"];
            this.fields.splice(index, 1, field);
        },
        savePassword() {
            if (this.$refs["update-password"].validate()) {
                this.$emit(
                    "update",
                    this.user.id,
                    this.$_.pick(this.passwords, [
                        "password",
                        "password_current",
                    ])
                );
            }
        },
    },
};
</script>

<style scoped>
</style>